var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 101,
    viewBox: "0 0 92 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.9H13.7222M13.7222 22.9H87.5M13.7222 22.9V87.3C13.7222 89.74 14.6938 92.08 16.4233 93.8054C18.1529 95.5307 20.4986 96.5 22.9444 96.5H69.0556C71.5014 96.5 73.8471 95.5307 75.5767 93.8054C77.3062 92.08 78.2778 89.74 78.2778 87.3V22.9M27.5556 22.9V13.7C27.5556 11.26 28.5272 8.91995 30.2567 7.19462C31.9862 5.46928 34.3319 4.5 36.7778 4.5H55.2222C57.6681 4.5 60.0138 5.46928 61.7433 7.19462C63.4728 8.91995 64.4444 11.26 64.4444 13.7V22.9",
    stroke: "#413C35",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.e643288e23a62d9f1ba7728500cac0b8.svg";
export { ForwardRef as ReactComponent };